import React from 'react';

import { useIsAdmin } from 'js/hooks/user';
import { useShowNotification } from 'js/hooks/useShowNotification';
import { copyToClipboard } from 'js/utils/clipboard.util';

import { TAdminComponentProps } from './types';

import style from './AdminComponent.scss';

export const AdminComponent: React.FC<TAdminComponentProps> = ({ id, dataId, prefix, isHideAdminPanel }) => {
    const isAdmin = useIsAdmin();
    const showNotification = useShowNotification();

    const copy = (value: string) => copyToClipboard(value).then(() => showNotification(`Copied ${value}`));

    if (!isAdmin) {
        return null;
    }

    return (
        <div className={style.container}>
            {!isHideAdminPanel && (
                <div
                    className={style.item}
                    onClick={() => copy(id)}
                >
                    {prefix} Portal ID:

                    {id}
                </div>
            )}

            <br />

            {dataId && (
                <div
                    className={style.item}
                    onClick={() => copy(dataId)}
                >
                    {prefix} DataId:

                    {dataId}
                </div>
            )}
        </div>
    );
};
